import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import s from './Subscription.module.css';
import IconSubscriptionExpireClock from '../../../../shared/ui/icons/IconSubscriptionExpireClock';

export default function SubscriptionAlertModal() {
    const subscription = useSelector((state: RootState) => state.subscription.userSubscription);

    if (!subscription) return null;

    const trialEnded = subscription.is_on_trial && subscription.is_trial_expired;
    const paymentFailed = subscription.is_payment_failed;

    if (!trialEnded && !paymentFailed) return null;

    const handleProceed = () => {
        window.location.href = `${window.location.origin}/settings?tab=subscription`;
    };

    let title = '';
    let message = '';
    let buttonLabel = '';

    if (paymentFailed) {
        title = 'Payment Failed';
        message =
            'We couldn’t process your latest payment. Please update your billing information to continue using SimpleeCreate.';
        buttonLabel = 'Update payment method';
    } else if (trialEnded) {
        title = 'Oops... Your trial has ended';
        message =
            'To keep using SimpleeCreate, please choose a subscription plan that works best for you.';
        buttonLabel = 'Upgrade your plan';
    }

    return (
        <div className={s.modalOverlay}>
            <div className={s.modal}>
                <div className={s.modalIcon}>
                    <IconSubscriptionExpireClock />
                </div>

                <h3>{title}</h3>
                <p>{message}</p>

                <button className={s.confirmBtn} onClick={handleProceed}>
                    {buttonLabel}
                </button>
            </div>
        </div>
    );
}
